import { render, staticRenderFns } from "./VideoSurveillance.vue?vue&type=template&id=1b4d19a0&scoped=true&"
import script from "./VideoSurveillance.vue?vue&type=script&lang=js&"
export * from "./VideoSurveillance.vue?vue&type=script&lang=js&"
import style0 from "./VideoSurveillance.vue?vue&type=style&index=0&id=1b4d19a0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b4d19a0",
  null
  
)

export default component.exports